<template>
    <div>
        <h1>Mes matériels
            <b-button to="/device/form">Ajouter</b-button>
        </h1>
        <b-row class="justify-content-center">
            <b-col cols="12">
                <devices-table ref="devicesTable" :devices="devices" :loading="loading" :show-actions="true"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from "axios";
    import {API_URL, REFRESH_FREQUENCY} from "../../variables";
    import DevicesTable from "./DevicesTable";

    function updateData() {
        axios
            .get(API_URL + "/user/devices")
            .then(response => {
                this.devices = response.data;
            })
            .finally(() => {
                this.loading = false;
                this.timeout = window.setTimeout(() => updateData.call(this), REFRESH_FREQUENCY * 1000);
            });
    }

    export default {
        name: "DevicesList",
        components: {
            DevicesTable
        },
        data() {
            return {
                devices: [],
                loading: true,
                timeout: null
            }
        },
        mounted() {
            updateData.call(this);
        },
        beforeDestroy() {
            window.clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>